// extracted by mini-css-extract-plugin
export default {"error-content":"styles_error-content__iIBBe"};